import * as Types from '../../../models.gen';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteBackgroundMutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type DeleteBackgroundMutation = { deleteBackground: { filename?: string | null, link?: string | null } };


export const DeleteBackgroundDocument = gql`
    mutation DeleteBackground($id: String!) {
  deleteBackground(id: $id) {
    filename
    link
  }
}
    `;
export type DeleteBackgroundMutationFn = Apollo.MutationFunction<DeleteBackgroundMutation, DeleteBackgroundMutationVariables>;

/**
 * __useDeleteBackgroundMutation__
 *
 * To run a mutation, you first call `useDeleteBackgroundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBackgroundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBackgroundMutation, { data, loading, error }] = useDeleteBackgroundMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBackgroundMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBackgroundMutation, DeleteBackgroundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBackgroundMutation, DeleteBackgroundMutationVariables>(DeleteBackgroundDocument, options);
      }
export type DeleteBackgroundMutationHookResult = ReturnType<typeof useDeleteBackgroundMutation>;
export type DeleteBackgroundMutationResult = Apollo.MutationResult<DeleteBackgroundMutation>;
export type DeleteBackgroundMutationOptions = Apollo.BaseMutationOptions<DeleteBackgroundMutation, DeleteBackgroundMutationVariables>;